import isEqual from 'lodash/isEqual';
import {connect} from "~/redux/connect";
import {getGlobalActionsRequiresSelection, getResultPerPage, getResultsValue, getTooltipsActive, getSearchFilterValue} from "~/stateGetter";
import Pagination from './ModelResultPagination';
import ResultTable from "./ModelResultTable";
import ResultCalendar from "./ModelResultCalendar";
import NavigatableTableBlueprint from "~/ui/components/ResultTable/NavigatableResultTable";
import getLoadingState from "~/conclude/loading";
import {compareKeys} from "mythil/object";
import { getCalendar } from '~/stateGetter';
import { modelActionsCreator } from "~/actions/model_actions";
import identify from "~/identify";
import { settingsActionCreator } from '../../actions/settingsActions';
import { getSelectedRows, getSelectThroughout } from '../../stateGetter';


const areStatePropsEqual = (prev, curr) => {
    let areEqual  = compareKeys(prev, curr, (prop, prevProp, key) => {
        switch(key) {
            
            case "searchFilterValue":
                return true;
            case 'loadingState':
            case 'commonProps':
                return isEqual(prop, prevProp);
            default:
                return prop === prevProp;
        }
    });

    if(!areEqual) {
        // console.log('NavigatableModelTable areStatePropsEqual PERF ', diffKeys(prev, curr));
    }

    return areEqual;
};

const _NavigatableResultTable = NavigatableTableBlueprint({Pagination,ResultTable, ResultCalendar});

const NavigatableModelTable = connect((state, {modelId, filterResultsValue}) => {
    let resultValue = getResultsValue(state, modelId),
        perPage = getResultPerPage(state, modelId),
        multiSelectable = getGlobalActionsRequiresSelection(state, modelId).length > 0,
        tooltipsActive = getTooltipsActive(state),
        modelCalendar = getCalendar(state, modelId);

    resultValue = filterResultsValue ? filterResultsValue(resultValue) : resultValue;

    return {
        multiSelectable,
        resultValue,
        perPage,
        tooltipsActive,
        hasSelections: getSelectThroughout(state, modelId) || getSelectedRows(state, modelId)?.length > 0,
        searchFilterValue: getSearchFilterValue(state, modelId, 3),
        ...modelCalendar,
        commonProps: { modelId },
        loadingState: getLoadingState(
            state,
            { loading: ['resultsLoading'], modelId }
        ),
    }
}, (dispatch, { modelId, }) => {
    const settingActions = settingsActionCreator(modelId);

    return {
        dispatch,
        updateCalendarView: (...props) => dispatch(settingActions.updateCalendarView(...props)),
        updateCalendarFilter: (name, value) => dispatch(settingActions.updateFilter(name, value, { filterType: "between" })),
    }
}, ({state, loadingState, ...props}, dispatchers, {modelId, ...ownProps}) => {
    return {
        ...props,
        ...ownProps,
        ...dispatchers,
        ...loadingState
    }
}, { areStatePropsEqual })(_NavigatableResultTable);


export default NavigatableModelTable;